import { Tooltip } from 'aa_common/front-end/antd'
import { ifElse } from 'aa_common/front-end/helpers'
import { getNs } from 'common/i18n-config'
import React, { useMemo } from 'react'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-detail'])
export const TooltipWrapper: React.FC<{
  children: React.ReactNode
  isShowTooltipMessage: boolean
  isDividingEvent?: boolean
  isStartUsageEventWithSubsidyAmount?: boolean
}> = ({ children, isShowTooltipMessage, isDividingEvent, isStartUsageEventWithSubsidyAmount }) => {
  useNsReady()
  const tooltipMessage = useMemo(() => {
    let tooltipMessage = t('tooltip_content.cancel_accelerated_depreciation_to_execute')

    if (isDividingEvent) {
      tooltipMessage = t('tooltip_content.cannot_cancel_divide_with_accelerated_depreciation')
    }

    if (isStartUsageEventWithSubsidyAmount) {
      tooltipMessage = t('tooltip_content.reduced_asset_start_usage_acquisition_date_match')
    }

    return tooltipMessage
  }, [isDividingEvent, isStartUsageEventWithSubsidyAmount])

  return (
    <Tooltip content={ifElse(isShowTooltipMessage, tooltipMessage, '')} placement="bottomRight">
      {children}
    </Tooltip>
  )
}
